import * as React from "react";
import { SVGProps } from "react";
const HelpIcon = (props: SVGProps<SVGSVGElement>) => (
  <div className="align-middle group hover:bg-[#D0D4DB] rounded-full  w-[33px] h-[33px] flex items-center justify-center p-1">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={33}
      height={33}
      data-name="Component 6435 \u2013 6"
      {...props}
    >
      <path
        fill="#172b4d"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12 0A12 12 0 1 1 0 12.289v-.722A11.955 11.955 0 0 1 12 0Zm0 15.475a1.2 1.2 0 0 0-1.192 1.051l-.008.139.008.151a1.2 1.2 0 0 0 2.383 0l.008-.139-.008-.151A1.2 1.2 0 0 0 12 15.475Zm1.642-7.943a3.6 3.6 0 0 0-4.357.867 1.183 1.183 0 0 0 .081 1.631 1.207 1.207 0 0 0 1.647.015l.205-.214a1.192 1.192 0 0 1 1.971 1.095 1.2 1.2 0 0 1-1.047.972l-.278.014A1.19 1.19 0 0 0 12 14.284a3.567 3.567 0 0 0 1.645-6.753Z"
        data-name="Path 5432"
      />
    </svg>
  </div>
);
export default HelpIcon;
